import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Owner } from '@app/forms/subscription/definition/interface/Pledge';
import { EsgObject } from '@app/forms/subscription/definition/interface/subscription';
import esgForm from '@app/forms/subscription/services/esgForm';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: EsgObject) {
    return esgForm.generatForm(entity, this.formBuilder);
    // let options: AbstractControlOptions = {};

    // return this.formBuilder.group(
    //   {
    //     ownerId: [entity.ownerId],
    //     userLastName: [entity?.userLastName || null],
    //     userFirstName: [entity?.userFirstName ? entity.userFirstName : null, ,],
    //     investments: [entity?.investments || ["null"]],
    //   },
    //   options
    // );
  }
  generate(entity: Owner[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  extract() {
    return this.form.value.owners;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
